export const GATEWAY_SERVICE_URL = process.env.GATEWAY_SERVICE_URL || '';
export const API_WS = process.env.API_WS || '';
export const MEDIA_SERVICE_URL = process.env.MEDIA_SERVICE_URL || '';
export const FILE_URL_3D = process.env.FILE_URL_3D || '';
export const DEBUG = process.env.DEBUG || '';
export const AZURE_INSIGHTS_KEY = process.env.AZURE_INSIGHTS_KEY || '';
export const ENABLE_EMULATION = process.env.ENABLE_EMULATION || '';
export const NODE_ENV = process.env.NODE_ENV || '';
export const APP_NAME = process.env.APP_NAME || '';
export const MAP_APIKEY = process.env.MAP_APIKEY || '';
export const ADMIN_EMAIL = process.env.ADMIN_EMAIL || '';
export const AG_GRID_LICENSE_KEY = process.env.AG_GRID_LICENSE_KEY || '';
export const AI_ASSISTANT_URL = process.env.AI_ASSISTANT_URL || '';

export const envConfig = {
  authUri: `${GATEWAY_SERVICE_URL}/signin`,
  gatewayServiceUrl: `${GATEWAY_SERVICE_URL}/graphql`,
  authTokenUrl: `${GATEWAY_SERVICE_URL}/auth-token`,
  apiWs: API_WS,
  mediaServiceUrl: MEDIA_SERVICE_URL,
  fileUrl: FILE_URL_3D,
  debug: DEBUG,
  azureInsightKey: AZURE_INSIGHTS_KEY,
  enableEmulation: ENABLE_EMULATION,
  nodeEnv: NODE_ENV,
  appName: APP_NAME,
  mapApiKey: MAP_APIKEY,
  adminEmail: ADMIN_EMAIL,
  agGridLicenseKey: AG_GRID_LICENSE_KEY,
  aiAssistantUrl: AI_ASSISTANT_URL,
};
